<template>
    <div v-if="showProgressBar" class="progress-bar">
        <p class="progress-bar__title">Вероятность одобрения займа</p>
        <div class="progress-bar__status">
            <div class="progress-bar__complete" v-bind:style="{'width': completeCurrentPercentWidth+'%'}">
                <div class="progress-bar__complete-percent">{{completeCurrentPercent}}%</div>
            </div>
            <div class="progress-bar__status-percent">+{{completeNextPercent}}%</div>
        </div>
    </div>
</template>

<script>
import widthMixin from '@/modules/mixins/widthMixin'

export default {
    name: "ProgressBar",
    mixins: [widthMixin],
	computed: {
		showProgressBar: function(){
			return this.$store.state.system.progressBarShow;
		},
		completeCurrentPercentWidth: function () {
			var widthCurrentPercent = this.$store.state.system.currentPercent;
			if(this.isDesktop || this.isTablet){
				widthCurrentPercent = widthCurrentPercent < 10 ? 10 : widthCurrentPercent;
			}else{
				widthCurrentPercent = widthCurrentPercent <= 10 ? 20 : widthCurrentPercent;
			}
			return widthCurrentPercent;
		},
		completeCurrentPercent: function () {
			return this.$store.state.system.currentPercent;
		},
		completeNextPercent: function () {
			return this.$store.state.system.nextPercent;
		},
    },
};
</script>

<style lang="scss">
@import "~@/assets/scss/variable";

.progress-bar {
  display: inline-flex;
  flex-flow: column wrap;
  justify-content: center;
  align-items: flex-start;
  margin: 40px auto 0;
  width: 611px;
  box-sizing: border-box;

  &__title {
    margin-left: 11px;
    color: #333333;
    font-family: $RobotoRegular;
    font-size: 14px;
    line-height: 16px;
  }
  &__status {
    display: inline-flex;
    flex-flow: row wrap;
    align-items: center;
    justify-content: flex-start;

    width: 100%;
    height: 20px;
    max-height: 20px;
    margin: 10px 0;
    background: #EEEEEE;
    border-radius: 10px;
    overflow: hidden;
  }
  &__status-percent {
    margin: 0 4px;
    color: #333333;
    font-family: $RobotoRegular;
    font-weight: 500;
    font-size: 12px;
    line-height: 14px;
  }
  &__complete {
    height: 100%;
    background: $yellow-site;
    text-align: right;
    border-radius: 10px;
  }
  &__complete-percent {
    margin: 0 14px;
    color: #FFFFFF;
    font-family: $RobotoRegular;
    font-weight: 500;
    font-size: 12px;
    line-height: 18px;//14px
  }
}
</style>
